module.exports = __webpack_public_path__ + "static/media/Pawniard_gaussian2.6f49d095.png";